import { useCallback } from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { cn } from '@/lib/core';

export interface FilterCheckboxItemProps {
  id: string;
  label: string;
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  className?: string;
}

export function FilterCheckboxItem({
  id,
  label,
  checked,
  onChange,
  disabled,
  className,
}: FilterCheckboxItemProps) {
  const handleCheckedChange = useCallback(
    (next: boolean | 'indeterminate') => {
      onChange(next === true);
    },
    [onChange]
  );

  return (
    <label
      htmlFor={id}
      className={cn(
        'flex cursor-pointer items-center gap-3',
        disabled && 'cursor-not-allowed opacity-40',
        className
      )}
    >
      <Checkbox id={id} checked={checked} onCheckedChange={handleCheckedChange} disabled={disabled} />
      <span
        className={cn(
          'font-pp-neue-montreal text-jncquoi-neutral-1000 text-[12px] leading-none tracking-[0.5px] uppercase',
          checked ? 'font-semibold' : 'font-normal'
        )}
      >
        {label}
      </span>
    </label>
  );
}
